import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { ConfigService } from './config.service';

@Injectable()

export class AesService {
    private secretKey: string = '';
    constructor(
        private _configService: ConfigService
    ) { 
        const env = this._configService.getClientEnv();
        this.secretKey = '1234567890123456';
        if (env === 'production') {
            this.secretKey = 'A9f$2Lq!7ZxP@3mK';
        }
    }

    // Encryption function
    encrypt(playerId: string): string {
        const key = CryptoJS.enc.Utf8.parse(this.secretKey);
        const encrypted = CryptoJS.AES.encrypt(playerId, key, { mode: CryptoJS.mode.ECB });
        return encrypted.toString();
    }

    // Decryption function
    decrypt(encryptedData: string): string {
        const key = CryptoJS.enc.Utf8.parse(this.secretKey);
        const decrypted = CryptoJS.AES.decrypt(encryptedData, key, { mode: CryptoJS.mode.ECB });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}